import React from 'react'
import PropTypes from 'prop-types'
import ShareIcons from '../../../shared/ShareIcons'
import RichText from '../../../shared/RichText'
import styles from '../index.module.scss'
import Img from '../../../shared/Img'

const Content = ({ content, slug, imageAsset, title }) => {
  return (
    <>
      <div className="m-auto mb-5 mr-3 h-36 w-full bg-gray-100 md:float-left md:mb-4 md:w-52 lg:mb-3">
        <a href={`/newsroom/${slug}/`} data-testid="imgLink">
          <Img
            data-testid="image"
            alt={imageAsset.title}
            src={imageAsset.url}
            className="m-auto h-full w-38"
          />
        </a>
      </div>
      <ShareIcons className="my-5 md:mb-4 md:mt-0" title={title} />
      <div className="md:initial" data-testid="article-content">
        <RichText
          key={slug}
          contentData={content}
          variants={['initial']}
          className={styles.richText}
        />
      </div>
    </>
  )
}

Content.propTypes = {
  content: PropTypes.object.isRequired,
  slug: PropTypes.string.isRequired,
  imageAsset: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
}
export default Content
